import React from 'react';
import PropTypes from 'prop-types';
import { SiteSelector } from './SiteSelector';
import { SiteSelectorList } from './SiteSelectorList';
import { TrackingUtils, withPageContext } from '../../utils';

export const SiteSelectorHeaderInner = ({ selected, websiteList, language, handleChange, trackEvent }) => {
    const websiteItem = websiteList.find((item) => item.id === selected);
    const flagIconClass = `odf-space-outer-top-s odf-flag odf-flag-xs odf-flag-${websiteItem?.icon?.toLocaleLowerCase()}`;

    const onClick = () => {
        const trackingAction = TrackingUtils.ACTION.HEADER;
        const trackingLabel = `header_country`;

        trackEvent({ action: trackingAction, label: trackingLabel });
    };

    const onChange = (event) => {
        const trackingAction = TrackingUtils.ACTION.HEADER;
        const trackingLabel = `header_country_${event.target.value}`;

        trackEvent({ action: trackingAction, label: trackingLabel });
        handleChange(event);
    };

    return (
        <div onClick={onClick}>
            <SiteSelectorList
                selected={selected}
                websiteList={websiteList}
                handleChange={onChange}
                styles={{ width: '90px', height: '30px', top: '15px' }}
            />
            <div style={{ pointerEvents: 'none' }}>
                <div className="odf-flex-container-row">
                    <div className="odf-flex-item">
                        <span className={flagIconClass} />
                    </div>
                    <div className="odf-flex-item">
                        <span
                            className="odf-text-mono-color-09"
                            dangerouslySetInnerHTML={{ __html: `${language.toUpperCase()} (${websiteItem?.currency})` }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

SiteSelectorHeaderInner.propTypes = {
    selected: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    websiteList: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

const SiteSelectorHeaderInnerWithContext = withPageContext(SiteSelectorHeaderInner);

export const SiteSelectorHeader = () => (
    <SiteSelector
        render={({ selected, websiteList, language, handleChange }) => (
            <SiteSelectorHeaderInnerWithContext selected={selected} websiteList={websiteList} language={language} handleChange={handleChange} />
        )}
    />
);
